export default "__VITE_ASSET__B_F9Arfa__"